import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { Options } from '@contentful/rich-text-react-renderer';
import { Block, BLOCKS, Inline } from "@contentful/rich-text-types";
import { SxProps } from '@mui/material';
import { ContentfulRichTextGatsbyReference, renderRichText, RenderRichTextData } from 'gatsby-source-contentful/rich-text';
import React, { ReactNode } from 'react';

export function sortAlphabetically(a: any, b: any, propName: string): number {
  var textA = a[propName].toUpperCase();
  var textB = b[propName].toUpperCase();
  return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
}

type ContentfulLivePreviewData = RenderRichTextData<null> & {
  json: any
}

const getContentfulLivePreviewDataOrFallback = (data: any) => {
  const typed = data as ContentfulLivePreviewData;
  return {
    raw: typed.json ? JSON.stringify(typed.json) : typed.raw,
    references: typed.references
  }
}

export function renderContentfulRichText<
  TReference extends ContentfulRichTextGatsbyReference
>(data: RenderRichTextData<TReference>, options?: Options): ReactNode {
  // return <></>
  if (!data) return <></>
  return renderRichText(getContentfulLivePreviewDataOrFallback(data), options);
}

export function renderContentfulRichTextNoParagraphPadding<
  TReference extends ContentfulRichTextGatsbyReference>(data: RenderRichTextData<TReference>, options?: Options): ReactNode {
  return renderContentfulRichText(data, {
    ...options,
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => <p style={{ marginBlockStart: 0, marginBlockEnd: 0 }}>{children}</p>,
    }
  })
}

export function convertRichTextToPlainText(data: Block | Inline): string {
  if (!data || !data.content || !data.data) return '';

  return documentToPlainTextString(data).trim()
}

export const footerPadding = { xs: 4, sm: 4, md: 6 }

export const contentBlockPadding: SxProps = { pl: { xs: 2, sm: 2, md: 'initial' }, pr: { xs: 2, sm: 2, md: 'initial' } }

export const extractPartnerReferralFromUrl = (locationSearch: string): { code: string; programCode?: string } | undefined => {
  if (!locationSearch) return undefined

  const params = new URLSearchParams(locationSearch)

  // New format: partner_{programCode}=partnerKey (e.g. ?partner_S7UFIWQH=BKbuBbGgsIjk)
  for (const [key, value] of params.entries()) {
    if (key.startsWith('partner_') && value) {
      const programCode = key.substring('partner_'.length)
      if (programCode) {
        return { code: value, programCode }
      }
    }
  }

  // Legacy format: partner=partnerKey (no program code, backend uses default program)
  const legacyCode = params.get('partner')
  if (legacyCode) {
    return { code: legacyCode }
  }

  return undefined
}
